import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import ActionService from "services/ActionService";

let initialState = { list: [] };

export const getRoleList = createAsyncThunk(
  "role/getRole",
  async () => {
    const response = await ActionService.getRoleList();
    return response?.results;
  }
);


export const addRoleList = createAsyncThunk(
  "role/addRoleList",
  async (body) => {
    const response = await ActionService.addRoleList(body);
    return response?.results;
  }
);

const roleSlice = createSlice({
  name: "role",
  initialState: initialState,
  reducers: {
    // clearAll: LoadingAdapter.getInitialState(initialState),
    // clearAsyncState: LoadingAdapter.clearAsyncState,
    updateRole: (state, action) => {
      const role = state.list.find(x => x.roleId === action.payload.roleId);
      if (role) {
        role.roleName = action.payload.roleName;
      }
    },
    addRole: (state, action) => {
      state.list = [...state.list, action.payload];
    },
    removeRole: (state, action) => {
      if (action.payload.role && action.payload.role.roleId) {
        const role = state.list.find(x => x.roleId === action.payload.role.roleId);
        if (role) {
          role.status = 'N';
        }
      }
      else {
        state.list.splice(action.payload.index, 1);
      }

    },
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getRoleList, builder, ["list"]);
    LoadingAdapter.applyAsyncBuilder(addRoleList, builder);
  },
});

export const {
  updateRole,
  addRole,
  removeRole
} = roleSlice.actions;


export default roleSlice.reducer;
